import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css';
import logo from '../images/logo.png';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <>
      <section id="footer" className="footer">
        <div className="footer-container">
          <div className="footer-col qr">
            <img src={logo} alt="QR Code" />
            <h2>OM Enterprise</h2>
          </div>

          <div className="footer-col">
            <h4>USEFUL LINKS</h4>
            <ul>
              <li><Link to="/">- Home</Link></li>
              <li><Link to="/About">- About Us</Link></li>
             
              <li><Link to="/Contact">- Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>ADDITIONAL LINKS</h4>
            <ul>
              <li><Link to="/cata">- Catalog</Link></li>
              <li><Link to="/enquiry">- Enquiry</Link></li>
              <li><Link to="/Gallery">- Gallery</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>CONTACT INFO</h4>
             <p><strong>Registered Address:</strong><br />
          Second Floor, Old No.5, New No.10, TRK Road,T.V Colony, Andalpuram, Madurai-625003 (INDIA)
        </p>
        <p><strong>Branch Address:</strong><br />
          8/2 RAJA STREET, SUBRAMANIYA PURAM MADURAI-625011(INDIA)
        </p>
            <p><a href="mailto:info@arguscarbide.com">om_enterprises@hotmail.co.in</a></p>
            <p><a href="tel:+919944210143">+91 9944210143</a></p>
            <p><a href="tel:+919944288801">+91 9944288801</a></p>
            <div className="social-icons">
              <a href="#"><i className="fab fa-facebook-f"></i></a>
              <a href="#"><i className="fab fa-twitter"></i></a>
              <a href="#"><i className="fab fa-instagram"></i></a>
              <a href="#"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 <strong>OM Enterprise Private Limited</strong>, All Rights Reserved.</p>
          <p>Powered By: <strong>OM Enterprise</strong></p>
        </div>
      </section>
    </>
  );
}
